module.exports = __webpack_public_path__ + "static/img/img8.cf7c3e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img8.png
// module id = uHWW
// module chunks = 1